import React, { useState, useEffect } from 'react'
import { MuiMultiSelect } from '../' 
import { removeHtmlTags } from '../../util'
import { FilterOuterWrap, FilterExpanded } from './style'

const ProgressionFilters = ({
  data,
  titles,
  settings,
  onChange,
  showSearch = true,
  onLoadShowData,
}) => {
  const drivers = data?.drivers || []
  const brands = data?.brands || []
  const periods = data?.periods || []
  const segments = data?.segments || []

  const [selected, setSelected] = useState({
    drivers: [],
    brands: [],
    periods: [],
    segments: [],
  })

  // Set the specific width requirement here
  const dropdownStyle = { maxWidth: '200px', width: '100%' };

  useEffect(() => {
    if (onLoadShowData && typeof onLoadShowData === 'object') {
      setSelected((prev) => ({ ...prev, ...onLoadShowData }))
    } else {
      setSelected({ drivers, brands, periods, segments })
    }
  }, [onLoadShowData, data])

  useEffect(() => {
    onChange(selected)
  }, [selected])

  const handleFilterChange = (key, value) => {
    setSelected((prev) => ({
      ...prev,
      [key]: value,
    }))
  }

  const handleSelectAll = (key, allData, isSelectingAll) => {
    setSelected((prev) => ({
      ...prev,
      [key]: isSelectingAll ? allData : [],
    }))
  }

  return (
    <FilterOuterWrap className="filterOuterWrap">
      <FilterExpanded className={`showSearch_${showSearch}`} sx={{  }}>
        {/* Segments */}
        {segments.length > 0 && (
          <MuiMultiSelect
            style={dropdownStyle}
            // title={titles?.segments || 'Segments'}
            data={segments}
            value={selected.segments}
            search={showSearch}
            placeholder="Select Segments"
            onChange={(val) => handleFilterChange('segments', val)}
            onSelectAll={(status) => handleSelectAll('segments', segments, status)}
          />
        )}

        {/* Periods */}
        {periods.length > 0 && (
          <MuiMultiSelect
            style={dropdownStyle}
            // title={titles?.periods || 'Periods'}
            data={periods.map(p => removeHtmlTags(p))}
            value={selected.periods}
            search={showSearch}
            placeholder="Select Periods"
            onChange={(val) => handleFilterChange('periods', val)}
            onSelectAll={(status) => handleSelectAll('periods', periods, status)}
          />
        )}

        {/* Brands */}
        {brands.length > 0 && (
          <MuiMultiSelect
            style={dropdownStyle}
            // title={titles?.brands || 'Brands'}
            data={brands}
            value={selected.brands}
            search={showSearch}
            placeholder="Select Brands 00000000"
            onChange={(val) => handleFilterChange('brands', val)}
            // onSelectAll={(status) => handleSelectAll('brands', brands, status)}
          />
        )}

        {/* Drivers */}
        {drivers.length > 0 && (
          <MuiMultiSelect
            style={dropdownStyle}
            // title={titles?.drivers || 'Drivers'}
            data={drivers}
            value={selected.drivers}
            search={showSearch}
            placeholder="Select Drivers"
            onChange={(val) => {
              // Logic for Radio mode: if multi-select returns an array, take only the last item
              const finalVal = settings?.driverRadio ? (val.length > 0 ? [val[val.length - 1]] : []) : val;
              handleFilterChange('drivers', finalVal);
            }}
            allCheckedByDefault={false}
            // onSelectAll={(status) => handleSelectAll('drivers', drivers, status)}
          />
        )}

      </FilterExpanded>
    </FilterOuterWrap>
  )
}

export default ProgressionFilters